import React from 'react';

import {
  FavoriteBorder as BaseFavoriteBorderIcon,
  Favorite as BaseFavoriteIcon
} from '@mui/icons-material';
import {
  IconButton,
  styled
} from '@mui/material';



const FavoriteIcon = styled(BaseFavoriteIcon)({
  color: '#EB5757'
});

const BlinkingFavoriteIcon = styled(BaseFavoriteIcon)({
  color: '#EB5757',
  WebkitAnimation: 'blinker 1s infinite',
  '@keyframes blinker': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.3 },
    '100%': { opacity: 1 }
  }
});

const FavoriteBorderIcon = styled(BaseFavoriteBorderIcon)({
  color: '#1E39498A'
});

const ElevatedIconButton = styled(IconButton)(({ theme }) => ({
  zIndex: theme.zIndex.mobileStepper,
  padding: 0
}));

interface IProps {
  favorited: boolean;
  transitioning?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export const FC: React.FC<IProps> = props => {
  const isDisabled = props.transitioning || props.disabled;

  const renderIcon = React.useCallback(() => {
    if (props.transitioning) {
      return <BlinkingFavoriteIcon />;
    }
    if (props.favorited) {
      return <FavoriteIcon />;
    }
    return <FavoriteBorderIcon />;
  }, [props]);



  return (
    <ElevatedIconButton
      disabled={isDisabled}
      onClick={isDisabled ? undefined : props.onClick}>
      {renderIcon()}
    </ElevatedIconButton>
  );
};
